import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png';
import meca from '../assets/meca.png'; 
import ray from '../assets/ray.png'; 
import robo from '../assets/robo.png'; 

const Header = () => {
  return (
    <header
      style={{
        background: '#001f3f',
        padding: '1rem',
        color: 'white',
        textAlign: 'center',
        position: 'relative', // necesario para contener el fondo absoluto
        overflow: 'hidden',
      }}
    >
      {/* Carrusel de imágenes como fondo */}
      <motion.div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          display: 'flex',
          width: '300%',
          height: '100%',
          zIndex: 0,
          opacity: 0.08, // controla visibilidad
        }}
        animate={{
          x: ['0%', '-100%'],
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: 'linear',
        }}
      >
        {[meca, ray, robo, meca, ray, robo].map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`carrusel-${i}`}
            style={{ width: '33.333%', objectFit: 'cover' }}
          />
        ))}
      </motion.div>

      {/* Contenido textual encima del carrusel */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <img src={logo} alt="Logo" style={{ maxWidth: '300px', height: 'auto' }} />
        <h1>SEINS - Servicios Estratégicos Integrales de Ingeniería Salvadoreños</h1>
        <nav>
          <a href="#servicios" style={{ margin: '0 1rem', color: '#fff' }}>Servicios</a>
          <a href="#nosotros" style={{ margin: '0 1rem', color: '#fff' }}>Nosotros</a>
          <a href="#contacto" style={{ margin: '0 1rem', color: '#fff' }}>Contacto</a>
          <a href="https://seinsv.com/admin/" target="_blank" rel="noopener noreferrer" style={{ margin: '0 1rem', color: '#fff' }}>Plataforma</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
